
export const getDocumentType = (mimeType) => {
    var type = 0; //Unknown

    if (mimeType) {
        var lcMimeType = mimeType.toLowerCase();
        if (lcMimeType.startsWith("image")) {
            type = 1; //Image
        } else if (lcMimeType.startsWith("")) {
            if (lcMimeType.endsWith("pdf")) {
                type = 2 //PDF
            }
        }
    }

    return type;
}